define.alias("ember-math-helpers/helpers/floor", "settings/helpers/floor");